import { createSlice } from "@reduxjs/toolkit";
/*

    filterLocation: can be {lat:x, long:y} data, or specify the county as a string. This will be managed on the backend.
    filters: [
        current widgets with there respective active filters
        {
            name:"Property Values",
            activeFilters: [
                {
                    name:"face Value",
                    type:"slider",
                    values: {min:0, max: 500}
                }
            ]
        }
    ]

*/

const initialState = () => ({
    currentBot: {
        totalEarnings: 0,
        botActivity: false,
        botFunds: 0,
        botName: null,
        botId:null,
        botRules: [],
        botMatches: 0,
        setupStatus: true,
        performanceData: {
            totalRewards: 0.00,
            totalKills: 0,
            totalDeaths: 0,
            botFundsDeposited: 0,
            avgGameLength: 0
        }

    },
    allBots:[
            // {
            //     botName: "Bot #156467",
            //     botNumber: 156467,
            // },
            // {
            //     botName: "Bot #564887",
            //     botNumber: 564887,
            // },
            // {
            //     botName: "Bot #888789",
            //     botNumber: 888789,
            // },
        ]
    
}
)


/* {todaysKills: 0, 
totalKills: 0, 
totalDead: 0, 
gameRewardsPerKill:9.3, 
currentDay:1, 
maxDay:27, 
playersRewards:{
    userTeam:[{userName:"name", totalKills:0, dead:false}], 
    enemyTeam:[{userName:"name", totalKills:0, dead:false}]
} */

const automateSlice = createSlice({
    name: 'Automate Status',
    initialState: initialState(),
    reducers: {
        resetGameProgress: state => initialState(),
        alterAllBots: (state,action) => {
            state.allBots = action.payload
        },
        alterCurrentBotPerformanceData: (state, action) => {
            state.currentBot.performanceData = action.payload
        },
        alterCurrentBot: (state, action) => {
            state.currentBot = action.payload
        },
        alterSetupStatus: (state, action) => {
            state.currentBot.setupStatus = action.payload
        }

    }
})

export const {
    resetGameProgress,
    alterCurrentBotPerformanceData,
    alterCurrentBot,
    alterSetupStatus,
    alterAllBots
} = automateSlice.actions

export default automateSlice.reducer